import React, {useEffect, useState} from "react";
import {Helmet} from "react-helmet";
import { makeStyles } from "@material-ui/core/styles";
import {DeviceHubOutlined} from "@material-ui/icons";
import useQueryParam from "../../hooks/useQueryParam";

const useStyles = makeStyles(() => ({
    container: {
        backgroundColor: "#fff",
        borderRadius: "10px",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh"
    },
    content: {
      textAlign: "center",
    },
    icon: {
        width: "80px",
        height: "80px",
        backgroundColor: "#3c7ef3",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "50%",
        margin: "0 auto 25px auto",

        "& svg": {
            fontSize: "50px",
            color: "#fff",
        }
    },
    footer: {
      display: "flex",
      justifyContent: "center",
    },
    goBackButton: {
        color: "#fff",
        border: "none",
        cursor: "pointer",
        padding: "6px 12px",
        fontSize: "0.9rem",
        fontWeight: "500",
        borderRadius: "4px",
        textDecoration: "none",
        backgroundColor: "#1e88e5",
        display: "flex",
        alignItems: "center",
        gap: "10px",
    }
}));

const NylasGreyAppConnect = () => {
    const code = useQueryParam("code");
    const state = useQueryParam("state");
    const classes = useStyles();
    const [dots, setDots] = useState("");
    const [isProcessing, setIsProcessing] = useState(true);
    const [pageInfo, setPageInfo] = useState(null);

    useEffect(() => {
        if (isProcessing) {
            const intervalId = setInterval(() => {
                setDots(prevDots => prevDots.length < 3 ? prevDots + "." : "");
            }, 500);

            return () => clearInterval(intervalId);
        }
    }, [isProcessing]);

    useEffect(() => {
        processRedirect();
    }, []);


    const processRedirect = async () => {
        setIsProcessing(true);
        let agencyDomain = "";
        let reference = "";

        try {
            const decodedState = atob(state);
            const parsedState = JSON.parse(decodedState); // { agencyDomain: "", agencyName: "", favIcon: "", reference: "", }

            agencyDomain = parsedState.agencyDomain;
            reference = parsedState.reference;

            const agencyName = parsedState.agencyName;
            const favIcon = parsedState.favIcon;

            setPageInfo({
                agencyName: agencyName,
                favIcon: favIcon,
            });

            let redirectUri = agencyDomain + "/user/email-connect-callback?code=" + code;

            if (reference){
                redirectUri += "&state=" + reference;
            }

            window.open(redirectUri, "_self");

        }catch (err){}
    };

      return (
          <div className={classes.container}>
              {
                  pageInfo &&
                  <Helmet>
                      <link rel="icon" href={pageInfo.favIcon} />
                      <title>{`Connect Personal Email | ${pageInfo.agencyName}`}</title>
                      <meta name="description" content="All-In-One Sales & Marketing Platform" />
                      <meta name="keywords" content={`CRM, Automation, Sales, Marketing, ${pageInfo.agencyName}`} />
                      <meta name="author" content={pageInfo.agencyName} />
                  </Helmet>
              }

              <div className={classes.content}>
                  <div className={classes.icon}>
                      <DeviceHubOutlined/>
                  </div>
                  <h4>Connect Personal Email</h4>

                  <h5 className="mt-4">
                      Wait while request is being verified
                      <span style={{ position: "absolute" }}>{dots}</span>
                  </h5>

                  <p>Please do not close the tab or change the page</p>
              </div>
          </div>
      );
};

export default NylasGreyAppConnect;